import React from "react";
import styles from "./Button.module.css";

function FunctionalButton({ children, handleClick, type }) {
  return (
    <button className={styles.button} type={type} onClick={handleClick}>
      {children}
    </button>
  );
}

export default FunctionalButton;
